import { httpsCallable, HttpsCallableResult } from "firebase/functions";

import { useWeb3React } from "@web3-react/core";

import { functions } from "../firebase";
import { useGnarlyGoatsContractsState } from "./useGnarlyGoatsContracts";

export const useFirebase = () => {
	const { account } = useWeb3React()
	const { accountMintPassBalance, accountBalance } =
		useGnarlyGoatsContractsState()

	const getAccountTokens = async (): Promise<any> => {
		try {
			const _getAccountTokens = httpsCallable(
				functions,
				`functions/account/tokens`
			)
			const tokens = (await _getAccountTokens({
				address: account,
				mintPassBalance: accountMintPassBalance,
				gmarlyGoatBalance: accountBalance,
			})) as HttpsCallableResult
			return tokens
		} catch (err) {}
	}

	/**
	 * Check if current account is whitelisted through firebase functions
	 * @returns whether current account is whitelisted or not
	 */
	const getAddressWhitelistStatus = async (): Promise<boolean> => {
		try {
			const getStatus = httpsCallable(
				functions,
				`functions/whitelist/addresses/${account}`
			)
			const status = ((await getStatus()) as HttpsCallableResult).data
			return status as boolean
		} catch (err) {
			console.log(err)
			return false
		}
	}

	/**
	 * Calculate the number of accounts in the current whitelist through firebase functions
	 * @returns number of whitelisted accounts or max length on failure
	 */
	const getWhitelistCount = async (): Promise<number> => {
		try {
			const getCount = httpsCallable(functions, `functions/whitelist/count`)
			const count = ((await getCount()) as HttpsCallableResult).data
			return count as number
		} catch (err) {
			console.log(err)
			return 1200
		}
	}

	/**
	 * Calculate the merkle root of the current whitelist through firebase functions
	 * @returns merkle root or empty string on failure
	 */
	const getMerkleRoot = async (): Promise<string> => {
		try {
			const getRoot = httpsCallable(
				functions,
				`functions/whitelist/merkle-root`
			)
			const root = ((await getRoot()) as HttpsCallableResult).data
			return root as string
		} catch (err) {
			console.log(err)
			return ''
		}
	}

	/**
	 * Calculate the merkle proof of the current account for the current whitelist through firebase functions
	 * @returns merkle proof or empty aray on failure
	 */
	const getMerkleProof = async (): Promise<string[]> => {
		try {
			const getProof = httpsCallable(
				functions,
				`functions/whitelist/merkle-proof/${account as string}`
			)
			const proof = ((await getProof()) as HttpsCallableResult).data
			return proof as string[]
		} catch (err) {
			return []
		}
	}

	/**
	 * Request that the current account be whitelisted through firebase functions
	 * @returns true if request is success
	 */
	const requestWhitelist = async (): Promise<boolean> => {
		try {
			const whitelist = httpsCallable(
				functions,
				`functions/whitelist/addresses`
			)
			const tx = await whitelist({ address: account })
			return true
		} catch (err) {
			console.log(err)
			return false
		}
	}

	return {
		getAccountTokens,

		getAddressWhitelistStatus,
		getWhitelistCount,
		getMerkleRoot,
		getMerkleProof,
		requestWhitelist,
	}
}
